import { styled } from 'styled-components';

export const Title = styled.span`
  font-size: 33px;
  opacity: 1;

  color: #000;
  text-align: center;
  font-feature-settings: 'case' on;
  font-family: Playfair Display;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const EventLocation = styled(Date)`
  opacity: 0.4;
  font-size: 14px;
  font-weight: 600;
`;

export const Text = styled.span`
  width: 350px;

  text-align: center;
  font-feature-settings: 'case' on;
  font-family: 'Poppins-Regular';

  font-size: 20px;

  line-height: 30px; /* 150% */
  letter-spacing: -0.408px;
`;

export const ButtonContainer = styled.span`
  gap: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const StyledText = styled(Text)`
  text-decoration: underline;
  width: unset;
  cursor: pointer;
`;

export const SmallText = styled(Text)`
  width: 381px;
  font-size: 14px;
  line-height: 22px;

  opacity: 0.5;
  @media (max-width: 540px) {
    width: 100%;
  }
`;
